import { render, staticRenderFns } from "./ClientGroups.vue?vue&type=template&id=30c49b5e"
import script from "./ClientGroups.vue?vue&type=script&lang=js"
export * from "./ClientGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports